import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import * as XLSX from 'xlsx';

@Injectable({
  providedIn: 'root'
})
export class BinaryReaderService {

  read(buffer$: Observable<ArrayBuffer>, filesTab: string): Observable<any[][]> {
    const workbook$ = buffer$.pipe(map(buffer => XLSX.read(buffer, { cellDates: true })));
    return workbook$.pipe(map(workbook => XLSX.utils.sheet_to_json(workbook.Sheets[filesTab], { header: 1 })));
  }
}
